import { motion } from "framer-motion";
import './index.css'
const FallbackComponent = () => {
  return (
    <motion.div
      key="fallback" // Ensure the component gets properly animated
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }} // Adjust duration as needed
      className="absolute z-50 w-full h-full flex items-center justify-center bg-white"
    >
      <div className="banter-loader">
        <div className="banter-loader__box"></div>
        <div className="banter-loader__box"></div>
        <div className="banter-loader__box"></div>
        <div className="banter-loader__box"></div>
        <div className="banter-loader__box"></div>
        <div className="banter-loader__box"></div>
        <div className="banter-loader__box"></div>
        <div className="banter-loader__box"></div>
        <div className="banter-loader__box"></div>
      </div>
    </motion.div>
  );
};

export default FallbackComponent;
